
import { baseUrl } from "../../constants";
import { getDDCompCall } from "../../redux/actions/dropDown";
import { setFullLoad } from "../../redux/actions/common";

export default {
    "formTitle": "Add Equipment Type",
    "tableTitle": "Equipment Type List",
    "apiDetails": {
        startUp: (dispatch) => {
            dispatch(setFullLoad(true));
            const dropDownArr = [getDDCompCall];
            setTimeout(()=>{
                dispatch(setFullLoad(false));
            }, 500);
            dropDownArr.forEach((func,) => {
                    dispatch(func());
            });
        },
        list: {
            url: `${baseUrl}/api/mms/equipment_type/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC",
                "column": "id"
            }
        },
        add: `${baseUrl}/api/mms/equipment_type`,
        edit: `${baseUrl}/api/mms/equipment_type/edit`,
        delete: `${baseUrl}/api/mms/equipment_type/remove`
    },
    "tableCol": [
        {
            name: 'Equipment Type',
            selector: row => row.name,
            sortable: true
        },
        {
            name: 'Equipment',
            selector: row => row.equipment_id,
            sortable: true
        },
        {
            name: 'Company',
            selector: row => row.comp_id,
            sortable: true
        },
        {
            name: 'Location',
            selector: row => row.loc_id,
            sortable: true
        },
        {
            name: 'Department',
            selector: row => row.department_id,
            sortable: true
        },
        {
            name: 'Area',
            selector: row => row.area_id,
            sortable: true
        },
        {
            name: 'Facility',
            selector: row => row.facility_id,
            sortable: true
        },
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'select',
                    label: 'Company',
                    name: 'comp_id',
                    "options": []
                },
                {
                    type: 'select',
                    label: 'Location',
                    name: 'loc_id',
                    "options": []
                },
                {
                    type: 'select',
                    label: 'Department',
                    name: 'department_id',
                    "options": [
                        "Agency",
                        "Logistics"
                    ],
                    // "required": true
                },
                {
                    type: 'select',
                    label: 'Area',
                    name: 'area_id',
                    "options": [
                        "Ship",
                        "Shore"
                    ],
                    // "required": true
                },
                {
                    type: 'select',
                    label: 'Facility',
                    name: 'facility_id',
                    "options": [
                        "Tester",
                        "Crew"
                    ],
                    // "required": true
                },
                {
                    type: 'select',
                    label: 'Equipment',
                    name: 'equipment_id',
                    "required": true
                },
                {
                    type: 'text',
                    label: 'Equipment Type',
                    name: 'name',
                    "required": true
                }
            ]
        }
    ],
    "mockData": [{
        "jobNature": "dgdg"
    }]
}